import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function tableGamesRouteI18n(): string {
  return (appRoutesI18nCache['table-games'] ??= $localize`:url-segment@@table-games-url-segment:table-games`);
}
